import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { ReactActionDialogBodyProps } from '../../../commonInfra/dialogs/ReactActionDialog';
import { ISiteUser } from '../../../ts/ServerApi/types/ISiteUser';
import { AuthenticationProviderSelector } from '../directives/AuthenticationProviderSelector';
import { IAuthenticationProvider } from '../services/SiteAuthenticationSettingsService';


export interface UpdateUserAuthenticationDialogProps {
    currentUser: ISiteUser;
    isAboutToBeLoggedOut: boolean;
}

export interface UpdateUserAuthenticationDialogState {
    authenticationProvider: IAuthenticationProvider;
    authenticationProviderIds: string[];
    authSetting: string;
    getProviderDisplayName: (provider: IAuthenticationProvider) => string;
    getProviderDescription: (provider: IAuthenticationProvider, inviteNotificationEnabledForSite: boolean) => string;
}

export type UpdateUserAuthenticationActionDialogBodyProps = ReactActionDialogBodyProps<UpdateUserAuthenticationDialogProps, UpdateUserAuthenticationDialogState>;

export function UpdateUserAuthenticationDialogBody(props: UpdateUserAuthenticationActionDialogBodyProps) {
    const [isAboutToBeLoggedOut, setAboutToBeLoggedOut] = React.useState(props.isAboutToBeLoggedOut);

    const onProviderChange = (provider: IAuthenticationProvider) => {props.updateDialogState({authenticationProvider: provider});};
    const onProviderIdsChange = (ids: string[]) => {props.updateDialogState({authenticationProviderIds: ids});};
    const onAuthSettingChange = (authSetting: string) => {props.updateDialogState({authSetting: authSetting});};

    React.useEffect(
      () => {
        const provider = props.dialogState.authenticationProvider;
        setAboutToBeLoggedOut(
          props.currentUser &&
            props.currentUser.authenticationProviderId !== provider.id
        );
      },
      // This deps array was noncompliant before we enabled the lint rule. If you're here, please consider fixing it! See TFS 1257824
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [props.dialogState.authenticationProvider]
    );

    return (
        <div className="tb-user-authentication-options">
            <AuthenticationProviderSelector {...props.dialogState} onProviderChange={onProviderChange} onProviderIdsChange={onProviderIdsChange} onAuthSettingChange={onAuthSettingChange}/>
            {isAboutToBeLoggedOut ?
                <div className="tb-dialog-error">
                    <div className="tb-indent">
                        {Messages.ssoBeforeYouContinue_aboutToBeLoggedOut()}
                    </div>
                </div>
            : null}
        </div>
    );
}

export function UpdateUserAuthenticationWarningDialog(): JSX.Element {
    return (
        <div>
            {Messages.updateUserAuthenticationWarning()}
            <div className="tb-dialog-error">{Messages.updateUserAuthenticationWarningDetails()}</div>
        </div>
    );
}
